import { render, staticRenderFns } from "./RatingProfileUpdate.vue?vue&type=template&id=b9de0170&scoped=true"
import script from "./RatingProfileUpdate.vue?vue&type=script&lang=js"
export * from "./RatingProfileUpdate.vue?vue&type=script&lang=js"
import style0 from "./RatingProfileUpdate.vue?vue&type=style&index=0&id=b9de0170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9de0170",
  null
  
)

export default component.exports